import { ServiceCallerProps } from "../../../../composition";

export interface Segment {
  id: number | string;
  name: string;
}

export interface Props extends ServiceCallerProps {
  segments: Array<Segment>;
  selectedSegments: Array<Segment>;
  setSelectedSegments: (tags: Array<Segment>) => void;
  allowEdit: boolean;
}

export const parseSegments = (from: Array<any>): Array<Segment> => {
  return from
    .filter((segment: any) => segment.tagName !== "NO_VIEWSPARK")
    .map((segment: any) => ({
      id: segment.id,
      name: segment.tagName,
    }));
};
